import { createApi } from '@shared/redux/createApi';

const tags = {
  getSaldoData: 'getSaldoData',
};

export const saldoApi = createApi({
  reducerPath: 'saldoApi',
  tagTypes: [tags.getSaldoData],

  endpoints: (builder) => ({
    saveDate: builder.mutation({
      query: (date) => ({
        method: 'post',
        url: '/admin/saldo/save-date',
        params: { date },
      }),
      invalidatesTags: [tags.getSaldoData],
    }),
    
    getBalanceDifference: builder.query({
      query: () => ({
        method: 'get',
        url: '/admin/saldo/balance-difference',
      }),
      providesTags: [tags.getSaldoData],
    }),
  }),
});

export const { 
  useSaveDateMutation,
  useGetBalanceDifferenceQuery
} = saldoApi; 